import React from 'react';
import { NavLink } from 'react-router-dom';
import './Footer.css';

const footerLinks = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About Us' },
  { to: '/publicdisclosure', label: 'Public Disclosure' },
  { to: '/facility', label: 'Facilities' },
  { to: '/gallery', label: 'Gallery' },
  { to: '/contact', label: 'Contact' }
];

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="footer-shell">
        <div className="footer-brand">
          <span className="footer-brand__eyebrow">Maxfort Education</span>
          <h3>A welcoming campus with stronger presentation and clearer user journeys.</h3>
          <p>
            Built for parents looking for a school environment that feels disciplined,
            supportive, and future-focused.
          </p>
        </div>

        <div className="footer-section">
          <h4>Contact</h4>
          <ul>
            <li>Bedwa Lamps Street, Near Vaghar Nagar, Partapur, Rajasthan - 327024</li>
            <li>
              <a href="tel:+919928620516">+91 9928620516</a>
            </li>
            <li>
              <a href="mailto:maxforteducationschool@gmail.com">maxforteducationschool@gmail.com</a>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Explore</h4>
          <ul>
            {footerLinks.map((link) => (
              <li key={link.to}>
                <NavLink to={link.to} end={link.to === '/'} onClick={scrollToTop}>
                  {link.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer-section">
          <h4>Social</h4>
          <div className="social-links">
            <a
              href="https://www.facebook.com/share/A2Td7dTwSd5BhD4W/?mibextid=qi2Omg"
              target="_blank"
              rel="noreferrer"
            >
              Facebook
            </a>
            <a
              href="https://www.instagram.com/maxfort_educationschool?igsh=N3V4eWRhZzFsc3J4"
              target="_blank"
              rel="noreferrer"
            >
              Instagram
            </a>
          </div>

          <button type="button" className="footer-top" onClick={scrollToTop}>
            Back to top
          </button>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; 2026 Maxfort Education School. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
